<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" [routerLink]="['/admin/series-listing']">
            <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a [routerLink]="['/admin/series-listing']">Series</a>
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <form novalidate [formGroup]="courseEditForm" (ngSubmit)="doSave()">
            <div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">

                <div class="app-c-form-group">
                    <label class="app-c-form--label">Group Name</label>
                    <input class="app-c-form-control" formControlName="groupname" type="text" />
                    <div class="error-message" *ngIf="f.groupname.touched && f.groupname.errors?.required">
                        Group name is required
                    </div>
                </div>

                <div class="app-c-accordion">
                    <details class="app-c-expansion-panel groupset" *ngFor="let chapter of dailydata.controls; let i = index" [formGroupName]="i">
                        <summary class="app-c-expansion-panel__header">
                            <span class="app-c-expansion-panel__title">Daily Content {{ i + 1 }}</span>
                            <span class="app-c-expansion-panel__description" *ngIf="dailydata.controls.length > 1">
                                <a class="removeGroup" tabindex="0" (click)="onRemoveDailyContentItem(i)"
                                    (keypress)="onRemoveDailyContentItem(i)"><img
                                        src="./assets/img/icons-svg/x-icon.svg" /></a>
                            </span>
                        </summary>

                        <ng-container padding>
                            <div class="app-c-form-group">
                                <label class="app-c-form--label" translate>Series Category</label>
                                <select class="app-c-form-control" formControlName="category">
                                    <option *ngFor="let category of categoryList" [value]="category.ID">
                                        {{ category.Title }}
                                    </option>
                                </select>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Daily Boost - English</label>
                                <textarea class="app-c-form-control" placeholder="Daily Boost - English" formControlName="quotesen"></textarea>
                                <div class="error-message" *ngIf="
									getDailyAddFormGroup(i).controls['quotesen'].touched &&
									getDailyAddFormGroup(i).controls['quotesen'].errors?.required
								">
                                    Daily Boost - English is required
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Daily Boost - French</label>
                                <textarea class="app-c-form-control" placeholder="Daily Boost - French" formControlName="quotesfr"></textarea>
                                <div class="error-message" *ngIf="
									getDailyAddFormGroup(i).controls['quotesfr'].touched &&
									getDailyAddFormGroup(i).controls['quotesfr'].errors?.required
								">
                                    Daily Boost - French is required
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Daily Boost - Spanish</label>
                                <textarea class="app-c-form-control" placeholder="Daily Boost - Spanish" formControlName="quoteses"></textarea>
                                <div class="error-message" *ngIf="
									getDailyAddFormGroup(i).controls['quoteses'].touched &&
									getDailyAddFormGroup(i).controls['quoteses'].errors?.required
								">
                                    Daily Boost - Spanish is required
                                </div>
                            </div>
                        </ng-container>
                    </details>
                </div>
                <a tabindex="0"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
                    (click)="addDailyContentItem({})" (keypress)="addDailyContentItem({})">
                    <svg-icon icon="plus" alt="plus"></svg-icon>
                    <span>Add Daily Content</span>
                </a>
                <div class="fixed-footer">
                    <p class="red" *ngIf="submitButtonPressed && !courseEditForm.valid && errors === ''">Please check
                        the errors</p>
                    <p class="red">{{errors}}</p>
                    <button type="button" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()">Save</button>
                </div>
            </div>
        </form>
    </div>
</div>
